import React from "react";
import { Link } from "react-router-dom";
import Logo1 from "../assests/apps/logoheader.png";

const Navbar = () => {
  return (
    <div className="">
      <div className="sticky   top-0 z-10 hidden md:flex justify-between px-5 py-4 bg-white md:py-6 ">
        <div className="absolute inset-0 shadow-lg opacity-50"></div>
        <div className="z-20 flex w-full sm:pr-10 md:pr-20">
          <a
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            href="/"
            // target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Logo1} alt="logo" className="w-10 -mt-3" />
          </a>
          <a href="/" className="mt-1 md:mt-0">
            <div className="text-lg md:text-2xl">
              Dapp<span className="text-blue-700">Walletnode</span>
            </div>
          </a>
        </div>
        <div className="z-20 md:flex hidden justify-around w-full text-blue-800 font-bold text-2xl sm:pr-10 md:pr-20">
          <Link
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            to="/"
          >
            Home
          </Link>
          <Link
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            to="/registry"
          >
            Connect Dconnect
          </Link>
          <Link
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            to="/"
          >
            Contact us
          </Link>
          <Link
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            to="/registry"
          >
            FAQ
          </Link>
        </div>
      </div>
      <div className="flex md:hidden justify-between px-4 pt-4">
        <div className="z-20 flex w-full sm:pr-10 md:pr-20">
          <a
            className="font-semibold text-cool-gray-500 hover:text-cool-gray-600 sm:text-xl"
            href="/"
            // target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Logo1} alt="logo" className="w-10 -mt-3" />
          </a>
          <a href="/" className="mt-1 md:mt-0">
            <div className="text-lg md:text-2xl">
              Dapp<span className="text-blue-700">Walletnode</span>
            </div>
          </a>
        </div>
        <div className="">
          <Link
            className="font-semibold mt-2 text-cool-gray-500 cursor-pointer hover:text-cool-gray-600 sm:text-xl text-blue-800 font-bold text-2xl -mt-2"
            to="/registry"
          >
            Connect
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
